import {Autocomplete, Box, Chip} from '@mui/material';
import {AppInput} from 'components/form';
import React from 'react';

interface MultiChipAutoCompleteBaseProps {
    options: string[];
    value: string[];
    validRegex?: RegExp;
    onChange: (event: React.SyntheticEvent, value: string[]) => void;
    searchValue: string;
    setSearchValue: (value: string) => void;
    onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    placeholder?: string;
    onlyEmail?: boolean;
}

const MultiChipAutoCompleteBase: React.FC<MultiChipAutoCompleteBaseProps> = ({
    options,
    value,
    onChange,
    searchValue,
    setSearchValue,
    onKeyDown,
    validRegex,
    placeholder = 'Invite Users',
}) => {
    const isValid = (value: string) => validRegex && validRegex.test(value.trim());
    return (
        <Autocomplete
            multiple
            freeSolo
            options={options}
            value={value}
            onChange={(event, newValue) => {
                if (Array.isArray(newValue)) {
                    const filtered = validRegex ? newValue.filter(isValid) : newValue;
                    onChange(event, filtered);
                } else {
                    onChange(event, []);
                }
            }}
            renderTags={(tagValue, getTagProps) => (
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 0.5,
                        maxHeight: 120,
                        overflowY: 'auto',
                    }}
                >
                    {tagValue.map((option, index) => (
                        <Chip size="small" variant="combined" label={option} {...getTagProps({index})} key={option} />
                    ))}
                </Box>
            )}
            renderInput={params => (
                <AppInput
                    {...params}
                    onChange={e => setSearchValue(e.target.value)}
                    onKeyDown={onKeyDown}
                    value={searchValue}
                    sx={{
                        minWidth: '300px',
                        '& .MuiInputBase-root': {
                            flexWrap: 'wrap',
                            alignItems: 'flex-start',
                            paddingTop: 1,
                            paddingBottom: 1,
                        },
                        '& input': {
                            flexBasis: '100%',
                            minWidth: 120,
                            marginTop: 0.5,
                        },
                        '& .MuiInputBase-input::placeholder': {
                            opacity: 1,
                        },
                    }}
                    placeholder={placeholder}
                    variant="outlined"
                />
            )}
        />
    );
};

export default MultiChipAutoCompleteBase;
